import Raven from 'raven-js';
import I18n from 'I18n';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export const GROUP_NAMES = {
  PROPERTIES: 'properties',
  CRM_SEARCH: 'crmSearch',
  USER_SETTINGS: 'userSettings',
  QUEUES: 'taskQueues',
  UNASSOCIATED_TASK_MODAL: 'unassociatedTaskModal',
  TABLE: 'tasksTable',
  CRM_OBJECT: 'crmObject',
  TASK_CREATE_UPDATE_DELETE: 'tasksCreateUpdateDelete',
  TASK_READ: 'tasksRead',
  GRAPHQL: 'graphQl',
  OWNERS: 'owners',
  TRACKING: 'tracking',
  APP_STARTUP: 'appStartup',
  TASK_VIEWS: 'taskViews'
};
export const _cleanObject = obj => JSON.parse(JSON.stringify(obj));
export const reportNewTasksWarning = (errorTitle, {
  groupName,
  functionName,
  extra,
  level = 'warning',
  tags = {}
} = {}) => {
  Raven.captureMessage(errorTitle, _cleanObject({
    level,
    tags: Object.assign({
      newApp: true,
      group: groupName,
      function: functionName
    }, tags),
    extra
  }));
};
export const addError = ({
  titleI18nKey,
  messageI18nKey,
  options,
  errorType = 'warning'
} = {}) => {
  const floatingAlertMessage =
  // @ts-expect-error legacy uage
  messageI18nKey && I18n.lookup(messageI18nKey) ? /*#__PURE__*/_jsx(FormattedMessage, {
    message: messageI18nKey,
    options: options
  }) : /*#__PURE__*/_jsx(FormattedMessage, {
    message: "tasksAlerts.genericError"
  });
  const titleText =
  // @ts-expect-error legacy uage
  titleI18nKey && I18n.lookup(titleI18nKey) ? /*#__PURE__*/_jsx(FormattedMessage, {
    message: titleI18nKey,
    options: options
  }) : /*#__PURE__*/_jsx(FormattedMessage, {
    message: "tasksAlerts.titles.genericError"
  });
  FloatingAlertStore.addAlert({
    titleText,
    message: floatingAlertMessage,
    type: errorType
  });
};

/**
 * @param {Error} newTasksError - The error that will appear in sentry
 * @param {Object} param1 - additional error details to help with debugging
 */
export const reportNewTasksError = (newTasksError, {
  groupName,
  functionName,
  extra
} = {}) => {
  extra = Object.assign({}, extra);
  console.error('reportNewTasksError', newTasksError, {
    groupName,
    functionName,
    extra
  });
  Raven.captureException(newTasksError, {
    // @ts-expect-error ts-migrate(2322) FIXME: Type 'boolean' is not assignable to type 'string'.
    tags: {
      newApp: true,
      group: groupName,
      function: functionName
    },
    extra: Object.assign({}, extra)
  });
};
export const reportAndDisplayError = (newTasksError, {
  messageI18nKey,
  titleI18nKey,
  options,
  errorType
}, {
  groupName,
  functionName,
  extra
} = {}) => {
  addError({
    titleI18nKey,
    messageI18nKey,
    options,
    errorType
  });
  reportNewTasksError(newTasksError, {
    groupName,
    functionName,
    extra
  });
};